var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cp-news-hub" },
    [
      _c("p", { staticClass: "validation" }, [_vm._v("Featured")]),
      _vm._v(" "),
      _c("featured-article", { attrs: { articleId: _vm.articleId } }),
      _vm._v(" "),
      _c("div", { staticClass: "cp-news-hub-container" }, [
        _c(
          "div",
          {
            class: "cp-news-hub-grid-container item-" + _vm.allNewsArticleCount
          },
          _vm._l(_vm.paginatedItems, function(article, index) {
            return _c(
              "a",
              {
                key: "news_" + index,
                staticClass: "cp-news-hub-grid-inner-container",
                attrs: { href: article.url }
              },
              [
                _c("div", { staticClass: "news-image-container" }, [
                  _c("img", {
                    staticClass: "news-image",
                    attrs: { src: _vm.GetImageCropper(article.imageUrl) }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "news-text-container" }, [
                  _c("p", { staticClass: "news-date" }, [
                    _vm._v(_vm._s(_vm.FormatDate(article.publishDate)))
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "news-title" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(article.title) +
                        "\n\t\t\t\t\t\t"
                    ),
                    _c("p", { staticClass: "news-author" }, [
                      _vm._v("by " + _vm._s(article.author))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "news-description" }, [
                    _vm._v(_vm._s(article.description))
                  ])
                ])
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        this.pageNumbers.length > 0 &&
        _vm.allNewsArticles.length > this.itemsPerPage
          ? _c(
              "div",
              {
                staticClass: "filter-projects-pagination-container",
                attrs: { id: "filter-projects-pagination-container" }
              },
              [
                _c(
                  "div",
                  { staticClass: "cp-news-hub-pagination-d" },
                  [
                    _c("i", {
                      staticClass:
                        "bi bi-arrow-left filter-projects-pagination-arrow filter-projects-pagination-arrow-left",
                      class: {
                        "filter-projects-pagination-arrow-disable":
                          _vm.currentPage == 0
                      },
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          _vm.prevPage()
                          _vm.HandleEllipse()
                          _vm.HandleArrows()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm._l(this.pageNumbersClone, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: "pageNumber_" + index,
                          staticClass: "cp-news-hub-nav-page-number",
                          class: {
                            "page-number-active": _vm.currentPage == item,
                            "page-number-ellipse": item == "..."
                          },
                          on: {
                            click: function($event) {
                              _vm.GoToPageNo(item)
                              _vm.HandleEllipse()
                              _vm.HandleArrows()
                            }
                          }
                        },
                        [
                          _c("p", [
                            _vm._v(_vm._s(item == "..." ? item : item + 1))
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass:
                        "bi bi-arrow-right filter-projects-pagination-arrow filter-projects-pagination-arrow-right",
                      class: {
                        "filter-projects-pagination-arrow-disable":
                          _vm.currentPage + 1 == _vm.pageCount
                      },
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          _vm.nextPage()
                          _vm.HandleEllipse()
                          _vm.HandleArrows()
                        }
                      }
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "cp-news-hub-pagination-m" }, [
                  _c("i", {
                    staticClass:
                      "bi bi-arrow-left filter-projects-pagination-arrow filter-projects-pagination-arrow-left",
                    class: {
                      "filter-projects-pagination-arrow-disable":
                        _vm.currentPage == 0
                    },
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function($event) {
                        _vm.prevPage()
                        _vm.HandleArrows()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Page " +
                        _vm._s(_vm.currentPage + 1) +
                        " of " +
                        _vm._s(_vm.pageCount)
                    )
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "bi bi-arrow-right filter-projects-pagination-arrow filter-projects-pagination-arrow-right",
                    class: {
                      "filter-projects-pagination-arrow-disable":
                        _vm.currentPage + 1 == _vm.pageCount
                    },
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function($event) {
                        _vm.nextPage()
                        _vm.HandleEllipse()
                        _vm.HandleArrows()
                      }
                    }
                  })
                ])
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }